import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TcAcceptRequest, TcStatus, TcStatusResponse } from './tnc.model';

/**
 * FCRA / Terms & Conditions API (FDD §3.1). Targets the live CSD API; the OIDC
 * bearer token is attached by the auth interceptor.
 */
@Injectable({ providedIn: 'root' })
export class TncService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.API_URL}/legal`;

  /** Current T&C version + this user's acceptance status. */
  getStatus(): Observable<TcStatus> {
    return this.http.get<TcStatusResponse>(`${this.base}/tc-status`).pipe(
      map((r) => ({
        tcVersionId: r.tc_version_id,
        versionNumber: r.version_number,
        effectiveDate: r.effective_date,
        contentText: r.content_text,
        accepted: r.accepted,
        acceptedAt: r.accepted_at,
      })),
    );
  }

  /**
   * Record acceptance of the given T&C version (204 No Content). The full FCRA
   * variant passes the signer's name; the short acknowledgement omits it and sends
   * only the version id.
   */
  accept(tcVersionId: number, name?: { firstName: string; lastName: string }): Observable<void> {
    const body: TcAcceptRequest = {
      tc_version_id: tcVersionId,
      ...(name ? { first_name: name.firstName, last_name: name.lastName } : {}),
    };
    return this.http.post<void>(`${this.base}/tc-accept`, body);
  }
}
